import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-approval-form',
  templateUrl: './training-approval-form.component.html',
  styleUrls: ['./training-approval-form.component.css']
})
export class TrainingApprovalFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Training/training-approval/training-approval-form/training-approval-form.component.ts